import { FeedCardParsedText } from "src/components/feed-card/common/feed-card-parsed-text";
import { IFeedCardSmartParagraphBody, TFeedCardSmartParagraphContentBlock } from "src/components/feed-card/types/content";
import { EnumFeedCardBlockType } from "src/components/feed-card/types/enums";

const allowedContentTypes: ReadonlyArray<TFeedCardSmartParagraphContentBlock["type"]> = [
    EnumFeedCardBlockType.Link,
    EnumFeedCardBlockType.Number,
    EnumFeedCardBlockType.Price,
    EnumFeedCardBlockType.Text,
];

interface IFeedSmartParagraphProps extends IFeedCardSmartParagraphBody {
    onLinkClick?: (url: string) => void;
}

export const FeedCardSmartParagraph = (props: IFeedSmartParagraphProps) => (
    <FeedCardParsedText {...props} allowedContentBlocks={allowedContentTypes} />
);
